export default __webpack_public_path__ + "9352e5412a2346a129b014484fd8359d.png";